import { call } from 'redux-saga/effects'
import { postHideCandidateProfile } from '../apiModules/candidateProfile'

export function* hideCandidateProfileSaga(candidateProfileId, data) {
  const response = yield call(postHideCandidateProfile, candidateProfileId, data)
  return response
}
